import { forwardRef, useCallback } from "react";
import { Link as RouterLink, NavLink as RouterNavLink, useNavigate as useRouterNavigate } from "react-router-dom";
import { useLang, localizedPath } from "./LanguageContext";

// Prefixes internal paths with /nl when the site is in Dutch.
// External URLs, hashes-only and already-prefixed paths pass through untouched.
export const localize = (to, lang) => {
  if (typeof to !== "string" || !to.startsWith("/") || to.startsWith("//")) return to;
  if (lang !== "nl") return to;
  const [path, hash] = to.split("#");
  const localized = localizedPath(path, "nl");
  return hash ? `${localized}#${hash}` : localized;
};

export const Link = forwardRef(({ to, ...props }, ref) => {
  const { lang } = useLang();
  return <RouterLink ref={ref} to={localize(to, lang)} {...props} />;
});
Link.displayName = "Link";

export const NavLink = forwardRef(({ to, ...props }, ref) => {
  const { lang } = useLang();
  return <RouterNavLink ref={ref} to={localize(to, lang)} {...props} />;
});
NavLink.displayName = "NavLink";

export const useNavigate = () => {
  const navigate = useRouterNavigate();
  const { lang } = useLang();
  return useCallback(
    (to, options) => navigate(typeof to === "string" ? localize(to, lang) : to, options),
    [navigate, lang]
  );
};
